import styled from "styled-components";
import Link from "next/link";
import {getNavPath} from "../../shared/navigateUtil";
import React, {useEffect, useState} from "react";
import {Col} from "react-bootstrap";
import {getTheme} from "../../shared/themeUtils";
import {useRouter} from "next/router";
import {IProductSpecial} from "../../interfaces/IProductSpecial";
// @ts-ignore
import ReactStars from "react-rating-stars-component";
import {useMessages} from "../../hooks/useMessages";

const Contain = styled.div`
    .rating-variation {
        display: flex;
        align-items: center;

        span.rating-count {
            margin-left: ${getTheme("space.1")};
        }
    }
    .entry {
        cursor: pointer;
        border: 1px solid ${getTheme("colors.border")};
        height: 100%;
        padding: ${getTheme("space.1")};
        display: flex;
        align-items: center;
        font-size: ${getTheme("fontSizes.small")};

        &:hover {
            border-color: ${getTheme("colors.secondaryFont")};
        }

        .img-contain {
            width: 100px;
            display: flex;
            align-content: center;
            justify-content: center;

            img {
                max-width: 80px;
                max-height: 80px;
            }
        }

        .content {
            padding: 0 ${getTheme("space.1")};

            .price {
                font-weight: bold;
            }
        }
    }
    
    .star-placeholder {
        height: 15px;
        width: 75px;
        background-color: #f0f0f0;
        margin-bottom: 4px;
    }
`

// ClientOnly wrapper for ReactStars to prevent hydration mismatch
const StarRating = ({ rating, count }: { rating: number, count: number }) => {
  const [isMounted, setIsMounted] = useState(false);
  
  useEffect(() => {
    setIsMounted(true);
  }, []);
  
  if (!isMounted) {
    return <div className="star-placeholder"></div>;
  }
  
  return (
    <ReactStars
      count={5}
      size={15}
      activeColor="#ffd700"
      edit={false}
      isHalf={true}
      value={rating}
    />
  );
};

type ProductPartPropsType = {
  product: IProductSpecial,
  quantity?: number
}

const ProductPart = (props: ProductPartPropsType) => {
  const {product, quantity} = props;
  const router = useRouter();
  const messagesQuery = useMessages()

  return (
    <Col xl={4} lg={6} md={12} key={product.productID} className="mb-3">
      <Contain>
        <Link href={getNavPath(router, `p/${product.slug}`)}>
          <div
            className={"entry"}>
            <div className="img-contain">
              <img src={product?.image?.imageUrl} alt={product.productName}/>
            </div>
            <div className="content">
              {product.overallReviewRating > 0 &&
                <div className="rating-variation">
                  <StarRating rating={product.overallReviewRating} count={product.productReviewsCount} />
                  <span
                    className={"text-muted rating-count"}>({product.productReviewsCount})</span>
                </div>}
              <div className="title">{product.productName}</div>
              <div className="price">
                {product.currencyPrice}
              </div>
              {quantity && messagesQuery.data &&
                <div className="pieces text-muted">
                  {`${quantity} ${messagesQuery.data.messages["piece-s"]}`}
                </div>
              }
            </div>
          </div>
        </Link>
      </Contain>
    </Col>
  )
}

export default ProductPart